function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? Object(arguments[r]) : {}, o = Object.keys(t); "function" == typeof Object.getOwnPropertySymbols && o.push.apply(o, Object.getOwnPropertySymbols(t).filter(function (e) { return Object.getOwnPropertyDescriptor(t, e).enumerable; })), o.forEach(function (r) { _defineProperty(e, r, t[r]); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == typeof e || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from 'react';
import BaseSchemaForm from '../../SchemaForm/BaseSchemaForm/BaseSchemaForm';
import BaseTextTemplate from '../../SchemaForm/TextTemplate/TextTemplate';
import ObjectFieldTemplate from '../../SchemaForm/ObjectFieldTemplate/ObjectFieldTemplate';
import { default as withFormBuilding, Addables } from '../withFormBuilding/withFormBuilding';
import { withBlueBoxZone, AutoEditContext } from '../BlueBoxZone/BlueBoxZone';
import uuid from '../../utils/uuid';
import set from '../../utils/set';
import compose from '../../utils/compose';
import noop from '../../utils/noop';
import { withAdditionalIntl } from '../../I18n/AdditionalIntl/AdditionalIntl';
import normalizeLocaleData from '../../utils/i18n/normalizeLocaleData';
import en from './locales/FormBuilder.en.json';
import { injectIntl } from 'react-intl';
import BlueBox from '../BlueBox/BlueBox';
import SchemaTextWidget from '../../SchemaForm/Widgets/TextWidget';
import SchemaRichTextWidget from '../../SchemaForm/Widgets/RichtextWidget';
import SchemaRadioWidget from '../../SchemaForm/Widgets/RadioWidget';
import SchemaCheckboxWidget from '../../SchemaForm/Widgets/CheckboxWidget';
import SchemaSelectWidget from '../../SchemaForm/Widgets/SelectWidget';
import I18n from '../../I18n/I18n/I18n';
var BlueBoxObjectFieldTemplate = withBlueBoxZone(ObjectFieldTemplate);
var messages = normalizeLocaleData(en, '@dm/components.form-builder');
var NOOP_PROVIDED = {
  innerRef: noop
};
var ADDABLES = [{
  label: '@dm/components.form-builder.labels.add-text',
  getAddSchemas: function getAddSchemas() {
    return {
      uiSchema: {
        'dm:layout': [{
          id: uuid(),
          type: 'text',
          escape: false,
          text: ''
        }]
      }
    };
  }
}];
export var FormBuilder = /*#__PURE__*/function (_React$Component) {
  _inherits(FormBuilder, _React$Component);
  function FormBuilder(props) {
    var _this;
    _classCallCheck(this, FormBuilder);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(FormBuilder).call(this, props));
    _this.translate = function (id) {
      return _this.props.intl.formatMessage({
        id: id
      });
    };
    _this.onAddItem = function (item) {
      var addSchemas = item.getAddSchemas();
      var schema = Object.assign({}, _this.props.schema, addSchemas.schema);
      var uiSchema = Object.assign({}, _this.props.uiSchema, addSchemas.uiSchema);
      _this.setState({
        autoEdit: true
      });
      _this.props.onUpdateAllSchema({
        schema: schema,
        uiSchema: uiSchema
      });
    };
    _this.renderAddables = function () {
      var _this$props$addables = _this.props.addables,
        addables = _this$props$addables === void 0 ? ADDABLES : _this$props$addables;
      return /*#__PURE__*/React.createElement(Addables, {
        addables: addables,
        onAddItem: _this.onAddItem
      });
    };
    _this.DraggableWidgets = {
      checkbox: withFormBuilding({})(SchemaCheckboxWidget),
      radio: withFormBuilding({})(SchemaRadioWidget),
      select: withFormBuilding({})(SchemaSelectWidget),
      richtext: withFormBuilding({})(SchemaRichTextWidget),
      text: withFormBuilding({})(SchemaTextWidget)
    };

    // @todo move this out (the schema part)
    _this.BlueBoxTextTemplate = withFormBuilding({
      getInitialFormData: function getInitialFormData(_ref) {
        var text = _ref.text;
        return {
          text: text
        };
      },
      schema: {
        title: _this.translate('@dm/components.form-builder.labels.add-text'),
        type: 'object',
        required: [],
        properties: {
          text: {
            type: 'string',
            title: _this.translate('@dm/components.form-builder.editor.label')
          }
        }
      },
      uiSchema: {
        text: {
          'ui:widget': 'textarea'
        }
      },
      updater: function updater(id, _ref2) {
        var schema = _ref2.schema,
          uiSchema = _ref2.uiSchema,
          formData = _ref2.formData;
        var layout = Array.from(uiSchema['dm:layout']);
        var index = layout.findIndex(function (item) {
          return item.id === id;
        });
        layout[index] = Object.assign({}, layout[index], {
          text: formData.text
        });
        return {
          schema: schema,
          uiSchema: set('dm:layout')(layout)(uiSchema)
        };
      }
    })(BaseTextTemplate);
    _this.state = {
      autoEdit: false
    };
    return _this;
  }
  _createClass(FormBuilder, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        _this$props$widgets = _this$props.widgets,
        widgets = _this$props$widgets === void 0 ? this.DraggableWidgets : _this$props$widgets,
        _this$props$TextTempl = _this$props.TextTemplate,
        TextTemplate = _this$props$TextTempl === void 0 ? this.BlueBoxTextTemplate : _this$props$TextTempl,
        schema = _this$props.schema,
        formData = _this$props.formData,
        uiSchema = _this$props.uiSchema,
        size = _this$props.size,
        onError = _this$props.onError,
        onChange = _this$props.onChange,
        onSubmit = _this$props.onSubmit,
        onUpdateUISchema = _this$props.onUpdateUISchema,
        onUpdateAllSchema = _this$props.onUpdateAllSchema,
        onEditStateChange = _this$props.onEditStateChange,
        _this$props$isRearran = _this$props.isRearrangeable,
        isRearrangeable = _this$props$isRearran === void 0 ? true : _this$props$isRearran,
        _this$props$isAddable = _this$props.isAddable,
        isAddable = _this$props$isAddable === void 0 ? true : _this$props$isAddable,
        _this$props$isDeletab = _this$props.isDeletable,
        isDeletable = _this$props$isDeletab === void 0 ? true : _this$props$isDeletab,
        _this$props$isRippleE = _this$props.isRippleEnabled,
        isRippleEnabled = _this$props$isRippleE === void 0 ? false : _this$props$isRippleE,
        _this$props$addables2 = _this$props.addables,
        addables = _this$props$addables2 === void 0 ? ADDABLES : _this$props$addables2,
        formContext = _this$props.formContext,
        children = _this$props.children;
      if (uiSchema['dm:layout'].length > 0) {
        return /*#__PURE__*/React.createElement(AutoEditContext.Provider, {
          value: this.state.autoEdit
        }, /*#__PURE__*/React.createElement(BaseSchemaForm, {
          formContext: _objectSpread({}, formContext, {
            onUpdateUISchema: onUpdateUISchema,
            onUpdateAllSchema: onUpdateAllSchema,
            onEditStateChange: onEditStateChange,
            isRearrangeable: isRearrangeable,
            isAddable: isAddable,
            isDeletable: isDeletable,
            addables: addables
          }),
          formData: formData,
          indentFields: isRippleEnabled,
          onChange: onChange,
          onError: onError,
          onSubmit: onSubmit,
          uiSchema: uiSchema,
          schema: schema,
          widgets: widgets,
          widgetSize: size,
          ObjectFieldTemplate: BlueBoxObjectFieldTemplate,
          TextTemplate: TextTemplate
        }, children));
      } else {
        return /*#__PURE__*/React.createElement(BlueBox, {
          draggable: false,
          active: true,
          isEditable: false,
          onClick: noop,
          onDoubleClick: noop,
          onMouseEnter: noop,
          onMouseLeave: noop,
          onFocus: noop,
          onBlur: noop,
          onApply: noop,
          onDelete: noop,
          provided: NOOP_PROVIDED,
          addables: isAddable ? this.renderAddables() : null
        }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(I18n, {
          i18n: "@dm/components.form-builder.messages.no-items"
        })));
      }
    }
  }]);
  return FormBuilder;
}(React.Component);
var enhanced = compose(withAdditionalIntl(messages), injectIntl)(FormBuilder);
enhanced.displayName = 'Enhanced(FormBuilder)';
export default enhanced;